import React from "react";

const Section2 = ({ onChangeInspectionComment, onChangeFieldComment, onAddInspectionCommentRow, onRemoveInspectionCommentRow, onAddFieldCommentRow, onRemoveFieldCommentRow, monthly_report_field_comment, monthly_report_inspection_comment }) => {
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 ">
                    <div className="appraisal-report-table-responsive">
                        <table className="assessment-table" cellSpacing={0}>
                            <tbody>
                                {/* Title */}
                                <tr>
                                    <td className="hd-s2" colSpan={4}>
                                        <p>4.　Important comment to dockyard / reply from yard
                                        </p>
                                    </td>
                                </tr>


                                {/* Dynamic Rows */}
                                <tr >
                                    <td className="td-s1 text-center">#</td>

                                    <td className="td-s1">
                                        <p className="s1">Inspection Comment</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Reply</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Action</p>
                                    </td>

                                </tr>
                                {/* Dynamic Rows */}
                                {monthly_report_inspection_comment.map((row, index) => (
                                    <tr key={index}>
                                        <td className="td-s1 text-center">{index + 1}</td>

                                        {/* Steel Cutting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Inspection Comment"
                                                name="comment"
                                                value={row.comment.value}
                                                onChange={(e) => onChangeInspectionComment(e, index)}
                                            />
                                        </td>

                                        {/* Block */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Reply"
                                                name="reply"
                                                value={row.reply.value}
                                                onChange={(e) => onChangeInspectionComment(e, index)}
                                            />
                                        </td>



                                        {/* Remove Row */}
                                        <td className="tb-input-value text-center">
                                            <button
                                                style={{
                                                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                    borderColor: "#2b5a7e"
                                                }}
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => onRemoveInspectionCommentRow(index)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {/* Add Row */}
                                <tr>
                                    <td colSpan={10}>
                                        <button
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                            type="button"
                                            className="btn btn-primary btn-sm ms-2"
                                            onClick={onAddInspectionCommentRow}
                                        >
                                            + Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tbody>

                        </table>


                        <table className="assessment-table" cellSpacing={0}>
                            <tbody>



                                {/* Dynamic Rows */}
                                <tr >
                                    <td className="td-s1 text-center">#</td>

                                    <td className="td-s1">
                                        <p className="s1">Field Comment</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Reply</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Action</p>
                                    </td>

                                </tr>
                                {/* Dynamic Rows */}
                                {monthly_report_field_comment.map((row, index) => (
                                    <tr key={index}>
                                        <td className="td-s1 text-center">{index + 1}</td>

                                        {/* Steel Cutting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Inspection Comment"
                                                name="comment"
                                                value={row.comment.value}
                                                onChange={(e) => onChangeFieldComment(e, index)}
                                            />
                                        </td>

                                        {/* Block */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Reply"
                                                name="reply"
                                                value={row.reply.value}
                                                onChange={(e) => onChangeFieldComment(e, index)}
                                            />
                                        </td>



                                        {/* Remove Row */}
                                        <td className="tb-input-value text-center">
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                 style={{
                                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                            borderColor: "#2b5a7e"
                                        }}
                                                onClick={() => onRemoveInspectionCommentRow(index)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {/* Add Row */}
                                <tr>
                                    <td colSpan={10}>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={onAddInspectionCommentRow}
                                        >
                                            + Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Section2;
